/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Event_Lead_CreatedInputs */

const cs_automation_event_lead_created = /** @type {(inputs: Automation_Event_Lead_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead vytvořen`)
};

const en_automation_event_lead_created = /** @type {(inputs: Automation_Event_Lead_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead created`)
};

/**
* | output |
* | --- |
* | "Lead created" |
*
* @param {Automation_Event_Lead_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_event_lead_created = /** @type {((inputs?: Automation_Event_Lead_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Event_Lead_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_event_lead_created(inputs)
	return cs_automation_event_lead_created(inputs)
});